var _defs, _rect, _path, _path2, _circle, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncentives(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".st-accent{fill:#ed0000;}.st-plate{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st-plate",
    x: 1,
    y: 1,
    width: 46,
    height: 46,
    rx: 3.54,
    ry: 3.54
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 30 13.5 41 19 38.5 22.5 42 23.4 32Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 30 34.5 41 29 38.5 25.5 42 24.6 32Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 20,
    r: 11
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st-accent",
    d: "M24 13.5 25.5 17.9 30.2 18 26.5 20.8 27.8 25.3 24 22.6 20.2 25.3 21.5 20.8 17.8 18 22.5 17.9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncentives);
export default __webpack_public_path__ + "static/media/incentives.24cc43f8f8e0803548c86e28b4b3ce51.svg";
export { ForwardRef as ReactComponent };